// src/components/ReassignModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';

const ReassignModal = ({
  show,
  onHide,
  assignmentId,
  oldExaminerId,
  oldExaminerName,
  onReassignSuccess
}) => {
  const [examinerOptions, setExaminerOptions] = useState([]);
  const [selectedExaminer, setSelectedExaminer] = useState('');

  // Fetch list of examiners when modal opens
  useEffect(() => {
    if (show) {
      axios
        .get('/api/users/role?roleName=examiner')
        .then((response) => {
          setExaminerOptions(response.data);
        })
        .catch((error) => {
          console.error('Error fetching examiners:', error);
        });
    }
  }, [show]);

  const handleSubmit = () => {
    if (!selectedExaminer) return;
    axios
      .put(
        `/api/exam-assignments/${assignmentId}/reassign?oldExaminerId=${oldExaminerId}&newExaminerId=${selectedExaminer}`
      )
      .then((response) => {
        if (onReassignSuccess) onReassignSuccess();
        onHide();
      })
      .catch((error) => {
        console.error('Error reassigning examiner:', error);
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Re-Assign Examiner</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Current Examiner</Form.Label>
            <Form.Control
              type="text"
              value={oldExaminerName}
              disabled
              style={{ backgroundColor: '#e9ecef' }}
            />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>Select New Examiner</Form.Label>
            <Form.Control
              as="select"
              value={selectedExaminer}
              onChange={(e) => setSelectedExaminer(e.target.value)}
            >
              <option value="">-- Select Examiner --</option>
              {examinerOptions
                .filter((option) => option.id !== oldExaminerId)
                .map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.fullName}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!selectedExaminer}>
          Re-Assign
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReassignModal;
